var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "layout reference-uniform",
      on: { scroll: _vm.handleScroll },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("m-description", { ref: "description" }),
      _c("m-type", {
        ref: "typeModal",
        attrs: { catalog: _vm.catalog.list },
        on: { created: _vm.onTypeCreated, updated: _vm.onTypeUpdated },
      }),
      _c("m-category", {
        ref: "categoryModal",
        attrs: { catalog: _vm.catalog.list },
        on: { created: _vm.onCategoryCreated, updated: _vm.onCategoryUpdated },
      }),
      _c(
        "div",
        {
          staticClass: "layout-header",
          class: {
            "reference-uniform-header-mb-0": _vm.status === "archive",
          },
        },
        [
          _c("div", { staticClass: "layout-title" }, [
            _vm._v("Структура каталога ТМЦ"),
          ]),
          _c("div", { staticClass: "layout-header-actions" }, [
            _c(
              "div",
              { staticClass: "layout-header-action" },
              [
                _vm.status !== "archive"
                  ? _c("c-button", {
                      attrs: {
                        size: "small",
                        label: "Новая категория",
                        icon: {
                          icon: "plus",
                          color: "primary",
                        },
                      },
                      on: { click: _vm.addCategory },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "layout-header-action" },
              [
                _vm.status !== "archive"
                  ? _c("c-button", {
                      attrs: {
                        size: "small",
                        label: "Новый тип ТМЦ",
                        icon: {
                          icon: "plus",
                          color: "primary",
                        },
                      },
                      on: { click: _vm.addType },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "reference-uniform-options" },
        [
          _c("c-switcher", {
            staticClass: "reference-uniform-options-switcher",
            attrs: {
              type: "group",
              items: [
                { label: "Все", value: "all" },
                { label: "Активные", value: "active" },
                { label: "В архиве", value: "archive" },
              ],
            },
            model: {
              value: _vm.status,
              callback: function ($$v) {
                _vm.status = $$v
              },
              expression: "status",
            },
          }),
          _c("c-input", {
            staticClass: "reference-uniform-options-search",
            attrs: {
              placeholder: "Поиск",
              "placeholder-style": "italic",
              icon: "search",
              type: "text",
              clearable: true,
            },
            on: { enter: _vm.updateList },
            model: {
              value: _vm.query,
              callback: function ($$v) {
                _vm.query = $$v
              },
              expression: "query",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "reference-uniform-list",
          attrs: { id: "reference-uniform-list" },
        },
        [
          !_vm.loading
            ? [
                _vm._l(_vm.catalog.list, function (category, categoryIndex) {
                  return [
                    _c("category", {
                      key: "category_" + category.id,
                      attrs: {
                        category: category,
                        sticked:
                          _vm.stickyCategoryId == "category_" + category.id,
                        last: _vm.catalog.list.length - 1 === categoryIndex,
                        root: true,
                      },
                      on: {
                        changeVisibility: _vm.categoryVisibleChange,
                        toggle: function ($event) {
                          return _vm.toggleCategory(category)
                        },
                        showDescription: function ($event) {
                          return _vm.showDescription(category)
                        },
                        edit: function ($event) {
                          return _vm.editCategory(category)
                        },
                        remove: function ($event) {
                          return _vm.removeCategory(category)
                        },
                      },
                    }),
                    category.subCategories.length > 0 ||
                    category.types.length > 0
                      ? _c(
                          "b-collapse",
                          {
                            key: `category_sub_${category.id}`,
                            staticClass: "reference-uniform-list-subcategories",
                            model: {
                              value: category.isVisible,
                              callback: function ($$v) {
                                _vm.$set(category, "isVisible", $$v)
                              },
                              expression: "category.isVisible",
                            },
                          },
                          [
                            _vm._l(
                              category.subCategories,
                              function (categoryChild, categoryChildIndex) {
                                return [
                                  _c("sub-category", {
                                    key: `category_sub_${categoryChild.id}_items`,
                                    attrs: { category: categoryChild },
                                    on: {
                                      toggle: function ($event) {
                                        return _vm.toggleCategory(categoryChild)
                                      },
                                      showDescription: function ($event) {
                                        return _vm.showDescription(
                                          categoryChild
                                        )
                                      },
                                      edit: function ($event) {
                                        return _vm.editCategory(categoryChild)
                                      },
                                      remove: function ($event) {
                                        return _vm.removeCategory(categoryChild)
                                      },
                                    },
                                  }),
                                  categoryChild.types &&
                                  categoryChild.types.length > 0
                                    ? _c(
                                        "b-collapse",
                                        {
                                          key: `category_sub_${categoryChild.id}_positions`,
                                          model: {
                                            value: categoryChild.isVisible,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                categoryChild,
                                                "isVisible",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "categoryChild.isVisible",
                                          },
                                        },
                                        _vm._l(
                                          categoryChild.types,
                                          function (type, typeIndex) {
                                            return _c("type", {
                                              key:
                                                "category_" +
                                                categoryIndex +
                                                "_subCategory_" +
                                                categoryChildIndex +
                                                "_position_" +
                                                typeIndex,
                                              attrs: {
                                                type: type,
                                                "in-subcategory": true,
                                              },
                                              on: {
                                                showDescription: function (
                                                  $event
                                                ) {
                                                  return _vm.showDescription(
                                                    type
                                                  )
                                                },
                                                edit: function ($event) {
                                                  return _vm.editType(type)
                                                },
                                                remove: function ($event) {
                                                  return _vm.removeType(type)
                                                },
                                                archiveOperation: function (
                                                  $event
                                                ) {
                                                  return _vm.archiveOperation(
                                                    type
                                                  )
                                                },
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              }
                            ),
                            _vm._l(
                              category.types,
                              function (categoryChild, categoryChildIndex) {
                                return [
                                  _c("type", {
                                    key:
                                      "category_" +
                                      categoryIndex +
                                      "_position_" +
                                      categoryChildIndex,
                                    attrs: { type: categoryChild },
                                    on: {
                                      showDescription: function ($event) {
                                        return _vm.showDescription(
                                          categoryChild
                                        )
                                      },
                                      edit: function ($event) {
                                        return _vm.editType(categoryChild)
                                      },
                                      remove: function ($event) {
                                        return _vm.removeType(categoryChild)
                                      },
                                      archiveOperation: function ($event) {
                                        return _vm.archiveOperation(
                                          categoryChild
                                        )
                                      },
                                    },
                                  }),
                                ]
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                }),
              ]
            : _vm._e(),
          !_vm.loading && _vm.catalog.list.length === 0
            ? _c("div", { staticClass: "reference-uniform-list-empty" }, [
                _vm._v(
                  " Ничего не найдено. Попробуйте изменить параметры поиска. "
                ),
              ])
            : _vm._e(),
          _vm.loading
            ? _c("c-loader", {
                staticClass: "reference-uniform-list-loader",
                attrs: {
                  label: "Загрузка данных",
                  active: _vm.loading,
                  height: "500",
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.scY > 138,
                expression: "scY > 138",
              },
            ],
            staticClass: "reference-uniform-scroll-top-button",
            attrs: { id: "pagetop" },
            on: { click: _vm.toTop },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "10",
                  height: "14",
                  viewBox: "0 0 10 14",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M5.68593 0.292893C5.2954 -0.0976311 4.66224 -0.0976311 4.27171 0.292893L0.292893 4.27191C-0.097631 4.66243 -0.0976311 5.2956 0.292893 5.68612C0.683417 6.07664 1.31658 6.07664 1.70711 5.68612L5.68593 1.70711C6.07645 1.31658 6.07645 0.683417 5.68593 0.292893Z",
                    fill: "#8E9CBB",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M4.29628 0.292893C4.6868 -0.0976311 5.31997 -0.0976311 5.71049 0.292893L9.68952 4.27191C10.08 4.66243 10.08 5.2956 9.68952 5.68612C9.299 6.07664 8.66583 6.07664 8.27531 5.68612L4.29628 1.70711C3.90575 1.31658 3.90575 0.683417 4.29628 0.292893Z",
                    fill: "#8E9CBB",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M4.97882 0.985811C4.42653 0.985811 3.97882 1.43353 3.97882 1.98581L3.97882 12.0015C3.97882 12.5537 4.42653 13.0015 4.97882 13.0015C5.5311 13.0015 5.97882 12.5537 5.97882 12.0015L5.97882 1.98581C5.97882 1.43353 5.5311 0.985811 4.97882 0.985811Z",
                    fill: "#8E9CBB",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }